import BilldeskLogo from '../icons/BillV1.svg';
import CamsLogo from '../icons/Cams.svg';
import LumpsumIcon from '../icons/Lumpsum.svg';
import SIPIcon from '../icons/Sip.svg';
import LumpsumSIPIcon from '../icons/Lumpsip.svg';
import RazorpayLogo from '../icons/RazorPay.svg';
import ePayLogo from '../icons/epay.png';
import CashFreeLogo from '../icons/cashFree.png';

export const GATEWAY_LOGOS = {
  Billdesk1: BilldeskLogo,
  CamsPay: CamsLogo,
  Billdesk2: BilldeskLogo,
};

export const TRTYPE_LOGOS = {
  Lumpsum: LumpsumIcon,
  Emandate: SIPIcon,
  Hybrid: LumpsumSIPIcon,
};

export const getAggregatorLogo = (aggregatorName: string) => {
  switch (aggregatorName?.toUpperCase()) {
    case 'BILLDESK1':
      return BilldeskLogo;
    case 'CAMS PAY':
    case 'CAMSPAY':
      return CamsLogo;
    case 'RAZORPAY':
      return RazorpayLogo;
    case 'EPAY':
      return ePayLogo;
    case 'CASHFREE':
      return CashFreeLogo;
    default:
      return BilldeskLogo; // Default logo
  }
};

export const AGGREGATOR_OPTIONS = [
  { value: 'Billdesk1', label: 'BILLDESK V1' },
  { value: 'Billdesk2', label: 'BILLDESK V2' },
  { value: 'CamsPay', label: 'CAMS Pay' },
  { value: 'RazorPay', label: 'RAZORPAY' },
  { value: 'Cashfree', label: 'CASHFREE' },
  { value: 'ePay', label: 'ePay' },
];

// Helper function to get aggregator label from value
export const getAggregatorLabel = (value: string): string => {
  const option = AGGREGATOR_OPTIONS.find(opt => opt.value === value);
  return option?.label || value;
};
